<template>
  <div>
    <guest-header />

    <section class="home-wrapper">
      <div class="home-slider">
        <ul class="bxslider">
          <li>
            <div class="slider-copy">
              <h1>APPLY FOR BID BONDS<br> QUICK &AMP; EASY</h1>
              <div class="tender-bidbond tender-bidbond-slider">
                <router-link
                  :to="linkUrl"
                  class="cta-button"
                >
                  <i class="fa fa-hand-o-up" />
                  <p>GET BID BOND</p>
                </router-link>
              </div>
            </div>
          </li>
          <!--          <li>-->
          <!--            <div class="slider-overlay">-->
          <!--              &lt;!&ndash;              <pic img-name="slider1.jpg" />&ndash;&gt;-->
          <!--            </div>-->
          <!--            <div class="slider-copy">-->
          <!--              <h1>APPLY FOR BID BONDS<br> QUICK &AMP; EASY</h1>-->
          <!--              <div class="tender-bidbond tender-bidbond-slider">-->
          <!--                <router-link-->
          <!--                  :to="linkUrl"-->
          <!--                  class="cta-button"-->
          <!--                >-->
          <!--                  <i class="fa fa-hand-o-up" />-->
          <!--                  <p>GET BID BOND</p>-->
          <!--                </router-link>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </li>-->
        </ul>
      </div>
    </section>

    <guest-footer />
  </div>
</template>
<style>
.home-wrapper{
  background: #cbd9e1;
}
.slider-overlay {
  position: relative;
}

.slider-overlay:before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  transition: background .3s linear;
}

.slider-copy h1{
  color: #FFFFFF !important;
}

</style>

<script>
import GuestHeader from "@/components/Guest/Header.vue";
import GuestFooter from "@/components/Guest/Footer.vue";
// import Pic from "@/components/Picture";

export default {
  components: {
    GuestHeader, GuestFooter
  },
  data() {
    return {
      linkUrl: '/login'
    }
  },
  mounted() {
    // setTimeout(() => {
    //   // eslint-disable-next-line no-undef
    //   $('.bxslider').bxSlider({
    //     adaptiveHeight: true,
    //     mode: 'horizontal',
    //     auto: true,
    //     touchEnabled: false,
    //     speed: 500,
    //     pause: 6000
    //   });
    //
    // }, 1000);
  },
  methods: {
    login() {
      if (this.$store.getters.getAuthUser.email) {
        this.linkUrl = '/dashboard/bidbonds';
      }
    }
  }
}
</script>
